import * as React from "react";
import { Tag, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const vehicles = [{
  id: 1,
  year: 2015,
  make: "Honda",
  model: "Civic",
  price: "$2,200",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2015_honda_civic_grey.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2015_honda_civic_grey.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2015_honda_civic_grey.png-wvc-sizes"
}, {
  id: 2,
  year: 2012,
  make: "Toyota",
  model: "Camry",
  price: "$1,800",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2012_toyota_camry_silver.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2012_toyota_camry_silver.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2012_toyota_camry_silver.png-wvc-sizes"
}, {
  id: 3,
  year: 2010,
  make: "Ford",
  model: "F-150",
  price: "$2,000",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2010_ford_f150_white.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2010_ford_f150_white.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2010_ford_f150_white.png-wvc-sizes"
}, {
  id: 4,
  year: 2008,
  make: "Chevy",
  model: "Malibu",
  price: "$800",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2008_chevy_malibu_blue.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2008_chevy_malibu_blue.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2008_chevy_malibu_blue.png-wvc-sizes"
}, {
  id: 5,
  year: 2006,
  make: "Honda",
  model: "Accord",
  price: "$1,200",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2006_honda_accord_black.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2006_honda_accord_black.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2006_honda_accord_black.png-wvc-sizes"
}, {
  id: 6,
  year: 2004,
  make: "Toyota",
  model: "Corolla",
  price: "$600",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2004_toyota_corolla_red.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2004_toyota_corolla_red.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2004_toyota_corolla_red.png-wvc-sizes"
}, {
  id: 7,
  year: 2002,
  make: "Nissan",
  model: "Altima",
  price: "$500",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2002_nissan_altima_silver.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2002_nissan_altima_silver.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2002_nissan_altima_silver.png-wvc-sizes"
}, {
  id: 8,
  year: 2000,
  make: "Ford",
  model: "Taurus",
  price: "$300",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2000_ford_taurus_green.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2000_ford_taurus_green.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2000_ford_taurus_green.png-wvc-sizes"
}, {
  id: 9,
  year: 2013,
  make: "Hyundai",
  model: "Elantra",
  price: "$1,500",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2013_hyundai_elantra_blue.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2013_hyundai_elantra_blue.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2013_hyundai_elantra_blue.png-wvc-sizes"
}, {
  id: 10,
  year: 2009,
  make: "Mazda",
  model: "3",
  price: "$950",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2009_mazda_3_grey.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2009_mazda_3_grey.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/2009_mazda_3_grey.png-wvc-sizes"
}];
export default function RecentlyBoughtVehicles() {
  return <section id="recently-bought-vehicles" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-12 md:mb-16 space-y-4">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tight">
            Recently Bought Vehicles
          </h2>
          <p className="text-lg text-muted-foreground max-w-[800px]">
            Take a look at some of the vehicles we've recently purchased. We buy cars in all conditions, from gently used to completely junked, and offer fair market prices.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-6">
          {vehicles.map((vehicle, i) => <Card key={vehicle.id} data-index={i} className="overflow-hidden flex flex-col border-border/50 shadow-sm hover:shadow-md transition-all duration-300 group">
              <div className="relative overflow-hidden">
                <AspectRatio ratio={4 / 3}>
                  <img src={vehicle.imageSrc} data-wvc-srcset={vehicle.imageSrcset} data-wvc-sizes={vehicle.imageSizes} alt={`${vehicle.year} ${vehicle.make} ${vehicle.model}`} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                </AspectRatio>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              
              <CardHeader className="p-4 pb-2 flex-grow">
                <CardTitle className="text-lg font-default leading-tight">
                  {vehicle.year} {vehicle.make} {vehicle.model}
                </CardTitle>
              </CardHeader>
              
              <CardContent className="p-4 pt-0 mt-auto">
                <div className="flex items-center justify-between bg-muted/50 p-3 rounded-md border border-border/50">
                  <span className="text-sm font-medium text-muted-foreground">We Paid:</span>
                  <Badge variant="default" className="text-sm px-2.5 py-1 font-semibold shadow-none">
                    <Tag className="w-3 h-3 mr-1" />
                    {vehicle.price}
                  </Badge>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Button asChild size="lg" className="rounded-full px-8">
            <Link to="/SellMyCarPage">
              Get an Offer for Your Car
              <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}